import { SovosCircularProgress } from 'mosaic-react';

interface LoaderProps {
	styles?: object;
	className?: string;
}

const defaultStyles = {
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
};

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => (
	<div style={props.className ? undefined : props.styles ?? defaultStyles} className={props.className}>
		<SovosCircularProgress aria-label='SovosCircularProgress' />
	</div>
);

export default Loader;
